import { render, staticRenderFns } from "./terms-checkbox.vue?vue&type=template&id=33ea6f8f&scoped=true&"
import script from "./terms-checkbox.ts?vue&type=script&lang=ts&"
export * from "./terms-checkbox.ts?vue&type=script&lang=ts&"
import style0 from "./terms-checkbox.scss?vue&type=style&index=0&id=33ea6f8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea6f8f",
  null
  
)

export default component.exports